import { render, staticRenderFns } from "./view_shop_product.vue?vue&type=template&id=cf0407e4"
import script from "./view_shop_product.vue?vue&type=script&lang=js"
export * from "./view_shop_product.vue?vue&type=script&lang=js"
import style0 from "./view_shop_product.vue?vue&type=style&index=0&id=cf0407e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports